import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  agency_id: undefined,
  custom_item_group_id: undefined,
  description: undefined,
  id: null,
  price: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'custom_item_group_id' },
  { key: 'price', validation: isValidPrice, invalidMessage: 'Invalid Value' },
  { key: 'title' },
]

export default state
